import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/lib/auth-context";
import { Button } from "@/components/ui/button";
import { FileDown, Loader2 } from "lucide-react";

export default function FeatureScopeButton() {
  const { isSuperAdmin } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!isSuperAdmin) return null;

  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get("/admin/feature-scope.pdf", { responseType: "blob" });
      const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || "zola-rewards-feature-scope.pdf";
      const a = document.createElement("a");
      a.href = URL.createObjectURL(res.data);
      a.download = name;
      a.click();
      URL.revokeObjectURL(a.href);
      toast.success("Feature scope downloaded");
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="w-card w-card-bordered p-6 mt-6 flex items-center justify-between gap-4 flex-wrap"
         data-testid="feature-scope-card">
      <div>
        <h3 className="font-bold">Feature Scope</h3>
        <p className="text-xs" style={{ color: "var(--text-muted)" }}>
          PDF of active pages, database structure, integrations and API endpoints — generated live.
        </p>
      </div>
      <Button type="button" onClick={download} disabled={busy} className="rounded-xl bg-navy text-white"
              data-testid="download-feature-scope-btn">
        {busy ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <FileDown className="h-4 w-4 mr-1.5" />}
        {busy ? "Generating…" : "Download Feature Scope"}
      </Button>
    </div>
  );
}
